var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomBudget2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.285 20.613c-10.6 13.018-9.138 32.312 3.29 43.504l18.502-23.18-21.792-20.324zM39.86 9.42h-.138c-8.132 0-15.945 3.325-21.701 9.273l21.838 20.37V9.42zM41.504 40.796l-19.92 24.96c13.524 10.256 32.62 7.305 42.626-6.556a31.982 31.982 0 0 0 5.985-18.404H41.504zM56.49 30.353c0-.75-.184-1.311-.503-1.733-.366-.421-.96-.796-1.828-1.217-2.147-.89-3.7-1.78-4.66-2.67-.96-.89-1.462-2.2-1.462-3.98 0-1.592.503-2.856 1.553-3.887 1.051-1.03 2.422-1.592 4.158-1.78v-2.95h2.147v2.998c1.645.234 2.924.936 3.884 2.06s1.416 2.576 1.37 4.355l-.045.047H56.58c0-1.03-.183-1.78-.594-2.248-.366-.515-.868-.749-1.508-.749s-1.142.187-1.416.609c-.32.421-.457.936-.457 1.545 0 .656.183 1.17.502 1.546.32.421.96.796 1.874 1.217 2.101.937 3.655 1.826 4.66 2.763 1.005.937 1.507 2.248 1.507 3.934 0 1.639-.502 2.903-1.507 3.933-1.005.984-2.33 1.593-4.02 1.733v2.81h-2.148v-2.81c-1.782-.187-3.244-.796-4.386-1.873s-1.736-2.67-1.69-4.777l.045-.093h4.478c0 1.17.228 1.966.73 2.482.503.515 1.143.749 1.92.749.639 0 1.142-.187 1.507-.609.228-.28.411-.796.411-1.405z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomBudget2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-budget-2.f4eb67541193f8d3f1bbcd8e74668e77.svg";